const UP_DOWN_TYPE = {
    RED_UP_GREEN_DOWN: 0,
    GREEN_UP_RED_DOWN: 1,
    PINK_UP_GREEN_DOWN: 2,
    GREEN_UP_PINK_DOWN: 3
};

const THEME = {
    CUSTOM: -1,
    LIGHT: 1,
    DARK: 3
};

const UP_DOWN_TYPE_CLS = {
    [UP_DOWN_TYPE.RED_UP_GREEN_DOWN]: 'red-up__green-down',
    [UP_DOWN_TYPE.GREEN_UP_RED_DOWN]: 'green-up__red-down',
    [UP_DOWN_TYPE.PINK_UP_GREEN_DOWN]: 'pink-up__green-down',
    [UP_DOWN_TYPE.GREEN_UP_PINK_DOWN]: 'green-up__pink-down'
};

const INCREASE_TYPE = {
    WEEK: 'weekIncrease', // 近一周涨幅
    MONTH: 'monthIncrease', // 近一月涨幅
    YEAR: 'yearIncrease', // 近一年涨幅
    YEAR_TO_DATE: 'ytdIncrease' // 年初至今涨幅
};

const TAG_SET = ['US', 'HK', 'SG', 'AU', 'CA', 'MY', 'JP', 'ADR', 'ETF', '股票', '期权', '轮证'];

export const SITE = {
    UNKNOWN: 0,
    ALL: -1,
    CN: 1,
    US: 2,
    SG: 3,
    AU: 4,
    JP: 5,
    HK: 6,
    MY: 8,
    CA: 9
};

export { UP_DOWN_TYPE, UP_DOWN_TYPE_CLS, INCREASE_TYPE, TAG_SET, THEME };
